// E700 runs on Chrome 52
import 'react-app-polyfill/stable'

import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'

import App from './App'
import { store, persistor } from './stores'
import configureServices from './utils/configureServices'

import 'react-toastify/dist/ReactToastify.css'
import './index.scss'
import { VNProvider } from 'vn-react-components/VNProvider'
import VNLoader from './VNLoader/components/VNLoader'

configureServices()

const Component = (
  <VNProvider>
    <Provider store={store}>
      <PersistGate loading={<VNLoader transparent text="Starting Up..." />} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </VNProvider>
)

const root = createRoot(document.getElementById('root'))
root.render(Component)
